import { Container } from "@mui/material";
import { BackButton } from "~/components/common/navigation";
import { Stack } from "~/components/ui/stack";
import { AddActivityScheduleForm } from "./components";

export const AddActivitySchedulePage = () => {
  return (
    <Container maxWidth="sm">
      <Stack gap="xlarge">
        <BackButton />
        <AddActivityScheduleForm />
      </Stack>
    </Container>
  );
};
